import React from 'react';
import {
  View,
  Pressable,
  StyleProp,
  ViewStyle,
  TextStyle,
  StyleSheet,
} from 'react-native';
import AVText from 'src/components/elements/AVText';
import Styles from 'src/components/Styles';
import {getDescriber} from './descriptor/DescriptorType';

const {customTilesButtonStyles} = getDescriber();

type CustomTilesButtonProps = {
  onTilePress: () => void;
  accessibleString: string;
  selected?: boolean;
  text: string;
  icon?: React.ReactNode;
  tileStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  testID?: string;
};

const CustomTilesButton = (props: CustomTilesButtonProps) => {
  return (
    <Pressable
      accessible={true}
      accessibilityLabel={props.accessibleString}
      nativeID={props.accessibleString || 'CustomTilesButton'}
      onPress={() => props.onTilePress()}
      testID={props.testID}
      accessibilityHint={`Tap to select ${props.text} `}
      accessibilityRole="button"
      aria-label={props.accessibleString}
      role="button"
      style={styles.touchable}
    >
      <View
        style={[
          customTilesButtonStyles().tileConatainer,
          props.selected && customTilesButtonStyles().selectedView,
          props.tileStyle,
        ]}
        nativeID={props.testID}
      >
        {props.icon}
        <AVText
          accessible={true}
          testID={props.text}
          accessibilityRole={'text'}
          accessibilityLabel={props.text}
          aria-label={props.text}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
          style={[
            customTilesButtonStyles().text,
            props.selected && customTilesButtonStyles().selectedText,
            props.textStyle,
          ]}
        >
          {props.text}
        </AVText>
      </View>
    </Pressable>
  );
};
const styles = StyleSheet.create({
  touchable: {
    backgroundColor: Styles.Colors.PayNew.white01,
    borderRadius: Styles.Spacing.m2,
    marginBottom: Styles.Spacing.m3,
    ...Styles.Style.lightShadow,
    minHeight: Styles.MinTouchableArea,
  },
});

export default CustomTilesButton;
